import React from 'react';

class Footer extends React.Component {

	render() {

		if(this.props.location.pathname === "/contact/") {
			var showFooter = false;
		} else {
			showFooter = true;
		}

		return (
			<footer className="site-footer">
				{ showFooter &&
					<div className="site-footer--container">
						<section className="site-footer--links">
								<ul>
									<li>
										<a href="/">Home</a>
										</li>
									<li>
										<a href="/work/logos/">Work</a>
									</li>
									<li>
										<a href="/new/">New</a>
									</li>
									<li>
										<a href="/about/">About</a>
									</li>
									<li>
										<a href="/contact/">Contact</a>
									</li>
								</ul>
							</section>
							<section className="site-footer--address">
								<span><strong>Chermayeff &amp; Geismar &amp; Haviv</strong><br/>
								27 West 24th Street, Suite 900<br/>
								New York, NY 10010<br/>
								212.532.4595</span>
							</section>
							<section className="site-footer--contact">
							<ul>
								<li>
									<span>
										<strong>Work Inquiries</strong><br/>
										<a href="mailto:info@cghnyc.com" rel="noopener" target="_blank">info@cghnyc.com</a><br/>
									</span>
								</li>
								<li>
									<span>
										<strong>Press Inquiries</strong><br/>
										Christopher Nutter<br/>
										917.770.0350<br/>
										<a href="mailto:press@cghnyc.com" rel="noopener" target="_blank">press@cghnyc.com</a>
									</span>
								</li>
							</ul>
								</section>
								<section className="site-footer--social">
								<ul>
                            <li>
                                <a href="https://twitter.com/cghnyc" rel="noopener" target="_blank">Twitter</a><br />
                            </li>
                            <li>
                                <a href="https://www.instagram.com/chermayeff_geismar_haviv/" rel="noopener" target="_blank">Instagram</a><br />
                            </li>
									<li>
										<a href="https://www.facebook.com/cghnyc" rel="noopener" target="_blank">Facebook</a>
									</li>
								</ul>
							</section>
					</div>
				}
			</footer>
		)
	}
}

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/Footer.js
 **/